import { SVGProps } from 'react';
const DriversAbstractSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={70}
		height={70}
		viewBox='0 0 240 240'
		{...props}
	>
		<defs>
			<clipPath id='a'>
				<path d='M147 114h51.754v110H147Zm0 0' />
			</clipPath>
		</defs>
		<path
			fill='#a6a6a6'
			d='M119.973 96.152c23.129 0 41.87-32.703 41.87-55.824 0-23.125-18.741-40.32-41.87-40.32-23.121 0-41.871 17.195-41.871 40.32 0 23.121 18.75 55.824 41.87 55.824M140.516 174.418l-11.473 6.644c-2.328 1.313-6.379 2.418-9.035 2.387h-.059c-2.687.031-6.738-1.074-9.031-2.387l-11.473-6.644c-3.465-2-3.699-6.86-.48-9.27a34.766 34.766 0 0 1 21.015-7.03c7.864 0 15.141 2.624 21.008 7.03 3.196 2.41 2.98 7.27-.472 9.27Zm13.707 12.816a24.52 24.52 0 0 1 5.156-.535h7.094c-3.157-22.832-22.801-40.504-46.493-40.504-23.726 0-43.335 17.672-46.496 40.504h7.086c1.766 0 3.496.176 5.13.535 1.288-2.863 4.859-4.175 7.78-2.504l5.368 3.098c5.804 3.371 10.039 7.453 13.976 11.84a9.637 9.637 0 0 0 7.156 3.156 9.686 9.686 0 0 0 7.153-3.156c3.93-4.387 8.164-8.469 13.23-11.422l6.078-3.484c2.922-1.703 6.47-.36 7.782 2.472M137.14 223.656c-6.55 3.692-14.394 5.332-22.644 4.082-4.176-.625-8.14-2.05-11.719-4.082a24.963 24.963 0 0 1-8.078 9.031 46.757 46.757 0 0 0 25.281 7.395 46.708 46.708 0 0 0 25.27-7.394 25.118 25.118 0 0 1-8.11-9.032'
		/>
		<path
			fill='#a6a6a6'
			d='M79.922 200.11H60.035c-.234-2.298-.41-4.614-.41-6.973 0-4.918.594-9.688 1.723-14.25 6.41-26.438 30.254-46.102 58.632-46.102 7.536 0 14.75 1.363 21.395 3.926L166 104.67a46.587 46.587 0 0 0-13.176-3.331c-.57-.063-1.164-.09-1.73-.153-8.766 7.567-19.285 12.458-31.114 12.458-11.863 0-22.359-4.891-31.148-12.457-.57.062-1.137.09-1.7.152-19.847 2.05-36.425 16.387-41.038 35.762-3.219 13.468-4.89 27.421-4.89 41.785v29.836c0 8.23 6.675 14.902 14.905 14.902H80.57c6.715 0 12.078-5.637 11.72-12.395-.33-6.355-6.02-11.12-12.368-11.12'
		/>
		<g clipPath='url(#a)'>
			<path
				fill='#a6a6a6'
				d='M193.867 137.102a46.582 46.582 0 0 0-12.91-22.594l-23.875 31.09c10.527 8.222 18.27 19.879 21.52 33.289a58.854 58.854 0 0 1 1.73 14.25c0 2.36-.152 4.675-.418 6.972H159.38a11.707 11.707 0 0 0-11.711 12.371c.328 6.38 6.02 11.145 12.398 11.145h23.782c8.226 0 14.906-6.672 14.906-14.902v-29.836c0-14.364-1.7-28.317-4.887-41.785'
			/>
		</g>
	</svg>
);
export default DriversAbstractSVG;
